import React from "react";
import { ArrowRight } from "lucide-react";
import { CONFIG, formatPrice } from "../config";
import { Reveal } from "../hooks/useReveal";
import { useLivePrice, directionColor } from "../hooks/useLivePrice";

const IMG =
  "https://images.unsplash.com/photo-1681108212545-04cabe9cf771?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGluZ290fGVufDB8fHx8MTc4Njg2MTAxM3ww&ixlib=rb-4.1.0&q=85&w=1200";

export default function FinalCTA() {
  const { price, direction } = useLivePrice();
  const priceColor = directionColor(direction);
  return (
    <section className="w-full py-[80px] lg:py-[160px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <span className="micro-label">Own the Metal</span>
              <h2 className="mt-5 text-[40px] sm:text-[54px] lg:text-[68px] font-medium tracking-[-0.03em] leading-[1.02] text-[#F1F2EF]">
                Own Platinum.
                <br />
                <span className="text-[#B5BAB7]">Digitally.</span>
              </h2>
              <p className="mt-7 text-[16px] text-[#A0A5A2]">1 {CONFIG.token} = 10 mg Platinum</p>
              <div
                className="mt-4 text-[36px] font-medium tracking-[-0.02em] tabular-nums"
                style={{ color: priceColor, transition: "color 0.5s ease" }}
              >
                {formatPrice(price)}
              </div>
              <div className="mt-9 flex flex-wrap items-center gap-3">
                <a
                  href={CONFIG.buyUrl || "#market"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-[#F0F1EE] px-6 py-3 text-[14px] font-medium text-[#080909] hover:bg-white transition-colors duration-200"
                >
                  Buy {CONFIG.token}
                  <ArrowRight size={16} strokeWidth={2} />
                </a>
                <a
                  href={CONFIG.whitepaperUrl || "#"}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-[#F0F1EE]/15 px-6 py-3 text-[14px] font-medium text-[#F1F2EF] hover:border-[#F0F1EE]/30 transition-colors duration-200"
                >
                  Read Whitepaper
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8">
            <div className="relative aspect-[4/5] w-full max-w-[420px] mx-auto">
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "radial-gradient(circle at 50% 42%, rgba(218,220,217,0.12), rgba(8,9,9,0) 60%)",
                }}
              />
              <div className="relative h-full w-full overflow-hidden rounded-[4px] border border-[#F0F1EE]/8">
                <img
                  src={IMG}
                  alt="Platinum"
                  className="h-full w-full object-cover"
                  style={{ filter: "brightness(0.78) contrast(1.04)" }}
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(8,9,9,0.1) 0%, rgba(8,9,9,0.6) 100%)",
                  }}
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
